import { Component, OnInit } from '@angular/core';
import { ManagedLinkKey } from 'src/common/managedLinkKey';
import { Observable } from 'rxjs';
import { AppState } from 'src/app/reducers';
import { Store } from '@ngrx/store';
import { ReportesToggleRequested } from '../../home/store/acceso/acceso.actions';
import { accesoReportesCollapsed } from '../../home/store/acceso/acceso.selectors';
import { collapseAnimation } from '../access.animations';

@Component({
	selector: 'report',
	templateUrl: './report.component.html',
	styleUrls: ['./report.component.scss'],
	animations: [ collapseAnimation ]
})
export class ReportComponent implements OnInit{

	reporteIncidentesKey: ManagedLinkKey = ManagedLinkKey.REPORTE_INCIDENTES;
	isCollapsed$: Observable<boolean>;

	constructor( private store: Store<AppState> ) {
	}

	ngOnInit() {
		this.isCollapsed$ = this.store.select( accesoReportesCollapsed );
	}

	toggleCollapse( event: Event ) {
		this.store.dispatch( new ReportesToggleRequested() );
		event.stopPropagation();
	}

}
